import Image from 'next/image';

import User from '@/components/Icons/User';
import nameToInitials from '@/helpers/nameToInitials';

import s from './UserImage.module.scss';

type Props = {
  url?: Parameters<typeof Image>[0]['src'];
  name?: string | null;
  size: number;
};

/**
 * @deprecated: Please use the Avatar and its subcomponents from `src/ui/core`
 */
const Avatar: React.FC<Props> = ({ url, name, size }) => {
  const urlIsString = typeof url === 'string';
  if (url && !(urlIsString && url.startsWith('#'))) {
    return (
      <Image
        src={url}
        alt={name || ''}
        className={s['user-image__image']}
        width={size}
        height={size}
        style={{ height: size, width: size }}
      />
    );
  }
  const initials = nameToInitials(name);

  return (
    <div style={{ transform: `scale(${size / 24})` }} className={s['user-image__letters']}>
      {initials || <User weight='fill' size={24} />}
    </div>
  );
};

export default Avatar;
